<template>
  <div>
    <CRow>
      <CCol>
        <CCard>
          <CCardBody>
            <CForm>
              <CTabs>
                <CTab>
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Dados de Cadastro
                  </template>
                  <br />

                  <CAlert
                    color="danger"
                    id="aviso"
                    name="aviso"
                    :show.sync="validacoes.aviso"
                    closeButton
                    >{{ validacoes.msg }}</CAlert
                  >
                  <CAlert
                    color="success"
                    id="sucesso"
                    name="sucesso"
                    :show.sync="validacoes.sucesso"
                    closeButton
                    >{{ validacoes.msg }}</CAlert
                  >
                  <CRow>
                    <CCol col="6">
                      <CCard>
                        <CCardBody>
                          <CInput
                            v-model="profissional.nome"
                            required
                            prepend="Nome"
                            invalid-feedback="* Campo obrigatório"
                          >
                            <template #append-content>
                              <CIcon name="cil-badge" />
                            </template>
                          </CInput>
                          <CInput
                            required
                            v-model="profissional.cpf"
                            v-mask="maskCpf"
                            @change="validarCpf"
                            prepend="CPF"
                            autocomplete="cpf"
                            invalid-feedback="* Campo obrigatório"
                          >
                            <template #append-content>
                              <CIcon name="cil-bank" />
                            </template>
                          </CInput>
                          <CInput
                            type="number"
                            v-model="profissional.rg"
                            invalid-feedback="* Campo obrigatório"
                            prepend="RG"
                          >
                            <template #append-content>
                              <CIcon name="cil-user" />
                            </template>
                          </CInput>
                          <CInput
                            v-model="profissional.crp"
                            v-mask="maskCrp"
                            prepend="CRP"
                            required
                            autocomplete="crp"
                            invalid-feedback="* Campo obrigatório"
                          >
                            <template #append-content>
                              <CIcon name="cil-at" />
                            </template>
                          </CInput>
                          <CInput
                            v-model="profissional.end"
                            prepend="ENDEREÇO"
                            invalid-feedback="* Campo obrigatório"
                          >
                            <template #append-content>
                              <CIcon name="cil-phone" />
                            </template>
                          </CInput>

                          <CInput
                            required
                            v-model="profissional.ocupacao"
                            prepend="OCUPAÇÃO"
                            autocomplete="Ocupação"
                            invalid-feedback="* Campo obrigatório"
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CInput>

                          <CInput
                            type="email"
                            required
                            v-model="profissional.email"
                            prepend="EMAIL"
                            autocomplete="Email"
                            invalid-feedback="* Campo obrigatorio"
                            @change="validateUsername()"
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CInput>
                          <CInput
                            v-model="profissional.cidade"
                            prepend="CIDADE"
                            autocomplete="Cidade"
                            invalid-feedback="* Campo obrigatorio"
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CInput>
                          <CInput
                            v-model="profissional.telefone"
                            v-mask="maskTel"
                            prepend="TELEFONE"
                            require
                            autocomplete="Telefone"
                            invalid-feedback="* Campo obrigatório"
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CInput>
                        </CCardBody>
                      </CCard>
                    </CCol>
                    <CCol col="6">
                      <CCard>
                        <CCardBody>
                          <h2>Cadastro de acesso</h2>
                          <CInput
                            disabled
                            v-model="profissional.email"
                            required
                            prepend="USUARIO"
                            autocomplete=""
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CInput>
                          <CInput
                            type="password"
                            prepend="SENHA"
                            required
                            v-model="profissional.senha"
                            @input="validarSenha"
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CInput>
                          <p
                            class="red"
                            v-for="(item, index) of erros"
                            :key="index"
                          >
                            {{ item }}
                          </p>
                          <!-- <CInput
                            required
                            type="password"
                            prepend="SENHA"
                            v-model="profissional.resenha"
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CInput> -->
                        </CCardBody>
                      </CCard>

                      <CCardBody style="  border: 1px solid #ccc">
                        <h2>% de Convênios</h2>
                        <div class="row">
                          <div
                            class="col-4"
                            v-for="item of convenio"
                            :key="item.id"
                          >
                            <CInput
                              required
                              :prepend="item.label"
                              v-model="item.percentage"
                              placeholder=""
                              type="number"
                              invalid-feedback="* Campo obrigatório"
                            >
                            </CInput>
                          </div>
                        </div>
                      </CCardBody>
                    </CCol>
                    <CCol col="6"> </CCol>
                    <CCol col="6">
                      <!-- <CCard>
                        <CCardBody>
                          <h2>Cadastro de Sala</h2>
                          <CSelect
                            :value.sync="profissional.sala"
                            :options="salas"
                            required
                            prepend="SALA"
                            autocomplete=""
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CSelect>
                          <CSelect
                            :options="turnos"
                            :value.sync="profissional.turno"
                            prepend="TURNO"
                          >
                            <template #append-content>
                              <CIcon name="cil-contact" />
                            </template>
                          </CSelect>
                        </CCardBody>
                      </CCard> -->
                    </CCol>
                  </CRow>
                  <CButton color="success" @click="cadastrarProfissional()"
                    >Cadastrar</CButton
                  >
                  <CButton
                    style="margin-left: 10px"
                    color="info"
                    @click="voltar()"
                    >Voltar</CButton
                  >
                </CTab>
              </CTabs>
            </CForm>
          </CCardBody>
          <CCardBody>
            <CAlert
              color="danger"
              id="aviso"
              name="aviso"
              :show.sync="validacoes.aviso"
              closeButton
              >{{ validacoes.msg }}</CAlert
            >
            <CAlert
              color="success"
              id="sucesso"
              name="sucesso"
              :show.sync="validacoes.sucesso"
              closeButton
              >{{ validacoes.msg }}</CAlert
            >
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { BIconTelephoneMinusFill } from "bootstrap-vue";
export default {
  name: "CadastrarProfissional",
  data() {
    return {
      maskCrp: "##/#####",
      maskCpf: "###.###.###-##",
      maskTel: "(##) #####.####",
      validacoes: {
        sucesso: false,
        aviso: false,
        msg: "",
        statusDados: false,
        ifs: false,
      },
      profissional: {
        sala: "",
        turno: "",
        nome: "",
        cpf: "",
        rg: "",
        crp: "",
        end: "",
        ocupacao: "",
        email: "",
        cidade: "",
        telefone: "",
        username: "",
        senha: "",
      },
      items: [],
      convenio: [],
      turnos: [
        { label: "Manha", value: "manha" },
        { label: "Tarde", value: "tarde" },
        { label: "Manha e Tarde", value: "manha_tarde" },
      ],
      turnoSelecionado: "",
      salas: [],
      erros: [],
    };
  },
  methods: {
    voltar() {
      this.$router.push("/profissionais");
    },
    listarProfissionais() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissionais`)
        .then((res) => res.json())
        .then((res) => {
          this.items = res;
        });
    },
    validarCpf() {
      this.items.forEach((item) => {
        if (this.profissional.cpf == item.cpf) {
          this.validacoes.msg = "CPF já existente";
          this.validacoes.aviso = true;
          setTimeout(() => {
            this.validacoes.aviso = false;
          }, 3000);
          this.profissional.cpf = "";
        }
        if (this.profissional.cpf.length < 14) {
          this.profissional.cpf = "";
          this.validacoes.aviso = true;
          this.validacoes.msg =
            "CPF inválido, verifique quantidade de caracteres inseridos";
          setTimeout(() => {
            this.validacoes.aviso = false;
          }, 3000);
        }
      });
    },
    converterMaiuscula(string) {
      const substring = string
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, function(p) {
          return p.toUpperCase();
        });
      return substring;
    },
    validarCampos() {
      if (!this.profissional.nome) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Nome do profissional precisa ser preenchido";
      } else if (!this.profissional.cpf) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "CPF do profissional precisa ser preenchido";
      } else if (!this.profissional.rg) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "RG do profissional precisa ser preenchido";
      } else if (!this.profissional.crp) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "CRP do profissional precisa ser preenchido";
      } else if (!this.profissional.end) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Telefone do profissional precisa ser preenchido";
      } else if (!this.profissional.ocupacao) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Ocupação do profissional precisa ser preenchido";
      } else if (!this.profissional.email) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Email do profissional precisa ser preenchido";
      } else if (!this.profissional.cidade) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Cidade do profissional precisa ser preenchido";
      } else if (!this.profissional.telefone) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Telefone do profissional precisa ser preenchido";
      } else if (!this.profissional.senha) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Profissional precisa cadastrar uma senha";
      } else {
        this.validacoes.ifs = true;
      }
    },
    validateUsername() {
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}validar-username`, {
          username: this.profissional.email,
        })
        .then((res) => res.json())
        .then((res) => {
          if (res[0].status == "Indisponível") {
            this.profissional.email = "";
            this.validacoes.msg = "Endereço de e-mail já cadastrado";
            this.validacoes.aviso = true;
            setTimeout(() => {
              this.validacoes.aviso = false;
            }, 3000);
          }
        });
    },
    //cadastro convenio
    cadastrarConvenio() {
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}convenios/cadastro`, {
          convenio: this.convenio,
        })
        .then((res) => {
          this.validacoes.msg = "Convênio cadastrado com sucesso";
          this.validacoes.sucesso = true;
          setTimeout(() => {
            this.$router.push("/profissionais");
          }, 1000);
        });
    },
    cadastro() {
      let valoresConvertidos = {
        nome: this.converterMaiuscula(this.profissional.nome),
        end: this.converterMaiuscula(this.profissional.end),
        ocupacao: this.converterMaiuscula(this.profissional.ocupacao),
        end: this.converterMaiuscula(this.profissional.end),
        cidade: this.converterMaiuscula(this.profissional.cidade),
      };
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}profissionais/novo`, {
          valoresConvertidos,
          profissional: this.profissional,
          convenio: this.convenio,
        })
        .then((res) => {
          this.cadastrarConvenio();
          this.validacoes.sucesso = true;
          this.validacoes.statusDados = false;
          // setTimeout(() => {
          //   this.$router.push("/profissionais");
          // }, 1000);
        });
      this.validacoes.sucesso = true;
      this.validacoes.msg = "Cadastro efetuado com sucesso";
      // setTimeout(() => {
      //   this.$router.push({
      //     name: "Profissionais",
      //   });
      // }, 500);
    },
    cadastrarProfissional() {
      if (this.erros.length > 0) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Senha inválida";

        return 
      }
      this.validarCampos();
      const expPassword = /^(?=.*\d)(?=.*[a-z])[0-9a-zA]{6,}$/;
      const expLogin = /[^\n]+@\S+\.\S+/;

      if (this.validacoes.ifs) {
        if (
          expLogin.test(this.profissional.email)
          // &&
          // expLogin.test(this.profissional.username)
        ) {
          if (this.erros.length == 0) {
            this.cadastro();
          } else {
            this.validacoes.aviso = true;
            this.validacoes.msg =
              "Senha inválida, mínimo 6 caracteres contendo letras e números";
            setTimeout(() => {
              this.validacoes.aviso = false;
            }, 3000);
          }
        } else {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Endereço de email inválido.";
          setTimeout(() => {
            this.validacoes.aviso = false;
          }, 3000);
        }
      }
    },
    listarConvenios() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}convenios`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.convenio.push({
              label: item.name,
              id: item.id,
              percentage: 0,
            });
          });
        });
    },
    ListarSalas() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}salas`)
        .then((res) => res.json())
        .then((res) => {
          this.salas = res.map((x) => {
            return {
              label: `${x.sala} - ${x.andar}° Andar `,
              value: x.sala,
            };
          });
          this.profissional.sala = this.salas[0].value;
          this.profissional.turno = "tarde";
        });
    },
    validarSenha() {
      this.erros = [];
      const senha = this.profissional.senha;
      const hasUppercase = /[A-Z]/.test(senha);
      const hasSpecialChar = /[^a-zA-Z0-9]/.test(senha);
      const hasLettersAndNumbers =
        /[a-zA-Z]/.test(senha) && /[0-9]/.test(senha);

      if (senha.length < 6) {
        this.erros.push("A senha deve ter 6 ou mais caracteres.");
      }
      if (!hasUppercase) {
        this.erros.push("A senha deve conter pelo menos uma letra maiúscula.");
      }

      if (!hasSpecialChar) {
        this.erros.push(
          "A senha deve conter pelo menos um caractere especial."
        );
      }

      if (!hasLettersAndNumbers) {
        this.erros.push("A senha deve conter letras e números.");
      }

      if (this.erros.length > 0) {
        // Exibir alertas de erro
        for (let erro of this.erros) {
          console.log(erro);
        }
      } else {
        // A senha atende aos critérios de validação
        console.log("A senha é válida");
      }
    },
  },

  mounted() {
    this.ListarSalas();
    this.listarConvenios();
    this.listarProfissionais();
  },
};
</script>

<style scoped>
.red {
  color: red;
  margin-bottom: 0px;
}
</style>
